import * as actionTypes from './concurrentUsersActionsTypes';
import type { ConcurrentUsersState } from './concurrentUsersReducers';

const updateConcurrentUsers = (concurrentUsers: ConcurrentUsersState) => ({
  type: actionTypes.UPDATE_CONCURRENT_USERS,
  concurrentUsers,
});

export { updateConcurrentUsers };
